import { useState, useEffect, useCallback } from "react";
import { ENDPOINT } from "../../../../constants/endpointConstants";
import {
  getToken,
  formatDateTime,
  getRangeDates,
} from "../../../../utils/utils";
import axios from "axios";

const InsightProducts = ({ startDate, endDate }) => {
  const [productsData, setProductsData] = useState(null);
  const [productsList, setProductsList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingProducts, setLoadingProducts] = useState(false);
  const [error, setError] = useState(null);
  const [selectedProduct, setSelectedProduct] = useState("");

  const getProductsData = useCallback(async () => {
    setLoading(true);
    setError(null);

    try {
      const token = getToken();
      const [dateInitFormatted, dateFinishFormatted] = getRangeDates(
        startDate,
        endDate
      );
      const requestBody = {
        startDate: formatDateTime(dateInitFormatted),
        endDate: formatDateTime(dateFinishFormatted),
      };

      if (selectedProduct) {
        requestBody.productIds = [parseInt(selectedProduct)];
      }

      const { data } = await axios.post(
        ENDPOINT.POST_SALES_BY_PRODUCT,
        requestBody,
        token
      );

      setProductsData(data);
    } catch (err) {
      setError("Error al cargar datos de productos");
      console.error("Error fetching products data:", err);
    } finally {
      setLoading(false);
    }
  }, [startDate, endDate, selectedProduct]);

  useEffect(() => {
    getProductsList();
  }, []);

  useEffect(() => {
    if (startDate && endDate && selectedProduct) {
      getProductsData();
    }
  }, [startDate, endDate, selectedProduct, getProductsData]);

  const getProductsList = async () => {
    setLoadingProducts(true);

    try {
      const token = getToken();
      const { data } = await axios.get(ENDPOINT.GET_PRODUCTS, token);

      setProductsList(data);
    } catch (err) {
      console.error("Error fetching products list:", err);
    } finally {
      setLoadingProducts(false);
    }
  };

  const formatCurrency = (value) => {
    return new Intl.NumberFormat("es-CL", {
      style: "currency",
      currency: "CLP",
    }).format(value);
  };

  const handleProductChange = (e) => {
    setSelectedProduct(e.target.value);
  };

  if (loadingProducts) {
    return (
      <div className="insight-loading">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Cargando productos...</span>
        </div>
      </div>
    );
  }

  return (
    <div className="products-content">
      <div className="product-dropdown">
        <select
          className="form-select cashier-select"
          value={selectedProduct}
          onChange={handleProductChange}
        >
          <option value="" disabled>
            Seleccione un producto
          </option>
          {productsList.map((product, index) => (
            <option value={product.productId} key={index}>
              {product.name}
            </option>
          ))}
        </select>
      </div>

      {selectedProduct && (
        <div className="products-data">
          {loading && (
            <div className="insight-loading">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Cargando datos...</span>
              </div>
            </div>
          )}

          {error && (
            <div className="insight-error">
              <p className="text-danger mb-0">{error}</p>
            </div>
          )}

          {!loading &&
            !error &&
            productsData &&
            productsData.products &&
            productsData.products.length > 0 && (
              <div className="products-list mt-3">
                {productsData.products.map((product) => (
                  <div key={product.productId} className="product-item">
                    <div className="product-info text-center d-flex flex-column gap-2">
                      <p className="fw-bold mb-1">
                        Cantidad:{" "}
                        <span className="fw-light">{product.totalAmount}</span>
                      </p>
                      <p className="fw-bold mb-1">
                        Valor:{" "}
                        <span className="fw-light">
                          {formatCurrency(product.totalRevenue)}
                        </span>
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            )}

          {!loading &&
            !error &&
            (!productsData ||
              !productsData.products ||
              productsData.products.length === 0) && (
              <div className="insight-empty">
                <p className="text-muted mb-0">
                  No hay datos disponibles para el producto seleccionado
                </p>
              </div>
            )}
        </div>
      )}
    </div>
  );
};

export default InsightProducts;
